//
//  SDKProject.ts
//  Supernova SDK
//
//  Created by Jiri Trecak.
//
// --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- ---
// MARK: - Imports
export class SDKProject {
    constructor(model) {
        this.id = model.id;
        this.name = model.name;
        this.createdAt = new Date(model.createdAt);
        this.contextId = model.contextId;
    }
    /**
     * Constructs a representation suitable for remote storage.
     * @returns The remote model of the project.
     */
    toRemote() {
        return {
            id: this.id,
            name: this.name,
            createdAt: this.createdAt.toISOString(),
            contextId: this.contextId,
        };
    }
    /**
     * Constructs a representation that can be serialized to JSON for transport.
     * @returns The transport model of the project.
     */
    toTransport() {
        return {
            id: this.id,
            name: this.name,
            createdAt: this.createdAt.toISOString(),
            contextId: this.contextId,
        };
    }
    /**
     * Reconstructs an SDKProject instance from a transport model.
     * @param model - The transport model to deserialize.
     * @returns A new SDKProject instance.
     */
    static fromTransport(model) {
        return new SDKProject({
            id: model.id,
            name: model.name,
            createdAt: model.createdAt,
            contextId: model.contextId,
        });
    }
}
